import 'babel-polyfill'
import 'isomorphic-fetch'

import React from 'react'
import ReactDOM from 'react-dom'
import {Http, config} from 'common'
import App from './App.jsx'

Http.configure({
    baseUrl: config.BASE_URL,
    debug: config.DEBUG,
    credentials: config.CREDENTIALS,
    errorPolicy: 'callback'
})


ReactDOM.render(
    <App />,
    document.querySelectorAll('#root')[0]
)
